import { useSelector } from 'react-redux';
import { millisecondsSince } from '../../language/time';
import {IAppState} from '../../core/redux/IAppState';
import {useEffect} from 'react';
import {useAuth0} from '@auth0/auth0-react';
import {redirectUri} from '../../index';

const LoginTimer = () => {
  const isLoggedIn = useSelector((state: IAppState) => state.auth.isLoggedIn);
  const loginExpiration = useSelector((state: IAppState) => state.auth.bearerTokenExp);
  const lastActivity = useSelector((state: IAppState) => state.lastActivity);
  const inactivityInterval = useSelector((state: IAppState) => state.resortToolsConfig.autoLogoutTimerMs || 15 * 60 * 1000);
  const {logout} = useAuth0();

  useEffect(() => {
    if (!isLoggedIn || !loginExpiration) {
      return;
    }

    const inactivityPeriod = lastActivity
      ? millisecondsSince(lastActivity)
      : 0;

    const expirationTime = inactivityInterval - inactivityPeriod;

    const timeout = window.setTimeout(() => {
       logout({logoutParams: {returnTo: redirectUri} });
    }, expirationTime);

    return () => {
      window.clearTimeout(timeout);
    };
  }, [isLoggedIn, loginExpiration, lastActivity, inactivityInterval, logout]);

  return null;
};

export default LoginTimer;
